import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TokenStorageService } from '@/core/services/internal/token-storage.service';
import {ToastService} from "@/core/services/internal/toast.service";

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private tokenStorageService: TokenStorageService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        // Optional: send to Sentry or remote logger here
        // console.log('[ErrorInterceptor] Caught error:', err);
        this.handleError(err);
        return throwError(() => err);
      })
    );
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    const isResetPasswordRoute = this.router.url.startsWith('/resetting-password');
    const isLoginRequest = err.url?.includes('/sso/login');
    const status = err.status;
    const title = err.error?.message || 'An unknown error occurred.';
    const message = err.error?.body.error_details || 'An unknown error occurred.';

      switch (status) {
        case 0:
          this.toastService.showToast(
            'Error',
            'We have a problem right now, please try later',
            'secondary',
            'secondary',
            true,
            50000
          );
          break;

        case 409:
          this.toastService.showToast(
            title,
            message,
            'warning',
            'warning',
            true,
            50000
          );
          break;

        case 422:
          this.toastService.showToast(
            title,
            message,
            'warning',
            'warning',
            true,
            50000
          );
          break;

        case 401:
        case 403:
          if (isResetPasswordRoute ||isLoginRequest ) {
            this.toastService.showToast(
              title,
              message,
              'danger',
              'danger',
              true,
              50000
            );
          } else {
            this.tokenStorageService.signOut();
            this.router.navigate(['/auth/login'], {
              replaceUrl: true
            }); // better than reload
          }
          break;

        default:
          this.toastService.showToast(
            title,
            message,
            'danger',
            'danger',
            true,
            50000
          );
          break;
      }

    // Recommended way to throw in RxJS 7+
    return throwError(() => err);
  }
}
